export const SHARE_LOGIN_HEADER_STRINGS = {
  platformName: 'Licensing Management Platform',
} as const
